export default "__VITE_ASSET__13daf545__"